export default __webpack_public_path__ + "static/media/AVISO-DE-PRIVACIDAD-DE-CONTROL-B.b826751c.pdf";